export const theme = {
  media: {
    small: "@media (min-width: 48em)", //768px
    medium: "@media (min-width: 63em)", //1024px
    large: "@media (min-width: 85.375em)", //1366px
    xlarge: "@media (min-width: 120em)", //1920px
    xxlarge: "@media (min-width: 160em)", //2560px
  },
  font: {
    base: "1em",
    header: "2em",
  },
}
